import { useEffect, useState } from 'react';
import { useFreelancerProfileStore } from '../stores/freelancerProfileStore';

export const useGetFreelancerOverallRating = ({ freelancerId }: { freelancerId: string }) => {
  const { fetch_freelancer_profile, freelancerProfiles } = useFreelancerProfileStore();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!freelancerId) return;

    const existingProfile = freelancerProfiles[freelancerId];
    if (!existingProfile) {
      setLoading(true);
      fetch_freelancer_profile(freelancerId).finally(() => setLoading(false));
    }
  }, [freelancerId, freelancerProfiles, fetch_freelancer_profile]);

  const profile = freelancerId ? freelancerProfiles[freelancerId] : null;
  const rating = profile?.stats?.overall_rating ?? 0;

  return { rating, loading };
};
